import { Component, OnInit, Input, ViewChild, HostListener,Output,EventEmitter } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { SQLService } from '../../../../services/sql.service';
import { page,fade,fade_in,display } from '../../../../app.animations';
import { NewSchedule } from '../../../../models/schedule';
import { Router } from '@angular/router';
import { IonSlides } from '@ionic/angular';
import { MenuController } from '@ionic/angular';
@Component({
  selector: 'app-intro-page-8',
  templateUrl: './8-eighth.page.html',
  styleUrls: ['./8-eighth.page.styl'],
})
export class IntroEighthPageComponent implements OnInit {
  @Input('save') save:boolean
  @Output('complete') complete = new EventEmitter();
  @ViewChild('intro_slider') slider: IonSlides;
  @HostListener('document:keypress', ['$event'])
  schedule = new NewSchedule(true);
  handleKeyboardEvent(event: KeyboardEvent) { 
  }
  constructor(
    public menu: MenuController,
    public sql: SQLService,
    public router: Router) { 
    this.router.events.subscribe((val) => {
      // 
    });
  }
  ngOnInit() {}
/**/
}